"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
var react_1 = __importDefault(require("react"));
exports.Tabs = function (props) {
    var tabs = props.tabs, activeTab = props.activeTab, onActive = props.onActive;
    return (react_1.default.createElement("div", { className: "ic-tabs" }, tabs === null || tabs === void 0 ? void 0 : tabs.map(function (tab, index) { return (react_1.default.createElement("button", { key: index, type: "button", className: "tab-item " + (activeTab === (tab === null || tab === void 0 ? void 0 : tab.value) ? "active" : ""), onClick: function () { return onActive(tab === null || tab === void 0 ? void 0 : tab.value); }, disabled: (tab === null || tab === void 0 ? void 0 : tab.count) === 0 }, tab === null || tab === void 0 ? void 0 :
        tab.label,
        " ",
        react_1.default.createElement("span", { className: "tab-item-count" }, (tab === null || tab === void 0 ? void 0 : tab.count) || 0))); })));
};
